(() => {
  const dialog = document.getElementById('BzSearchDialog');
  if (!dialog || dialog.dataset.visualReady) return;
  dialog.dataset.visualReady = 'true';

  const camera = dialog.querySelector('[data-bz-camera]');
  const fileInput = dialog.querySelector('[data-bz-camera-input]');
  const panel = dialog.querySelector('[data-bz-visual]');
  if (!camera || !fileInput || !panel) return;

  const preview = panel.querySelector('img');
  const text = panel.querySelector('[data-bz-visual-text]');
  const remove = panel.querySelector('[data-bz-visual-remove]');
  const searchInput = dialog.querySelector('input[type="search"]');
  const idle = dialog.querySelector('.bz-search-idle');
  const typedResults = dialog.querySelector('#BzSearchResults');
  const indexUrl = dialog.dataset.visualIndex;
  const MAX_BYTES = 12 * 1024 * 1024;
  const results = document.createElement('div');
  results.className = 'bz-visual-results';
  results.hidden = true;
  panel.after(results);

  let objectUrl = null;
  let indexPromise = null;
  let runId = 0;

  /* Same feature extractor used to build the catalogue index */
  function features(img) {
    const N = 96;
    const canvas = document.createElement('canvas');
    canvas.width = N;
    canvas.height = N;
    const ctx = canvas.getContext('2d', { willReadFrequently: true });
    ctx.fillStyle = '#fff';
    ctx.fillRect(0, 0, N, N);
    const w0 = img.naturalWidth || img.width;
    const h0 = img.naturalHeight || img.height;
    const s = Math.min(N / w0, N / h0);
    const w = w0 * s;
    const h = h0 * s;
    ctx.drawImage(img, (N - w) / 2, (N - h) / 2, w, h);
    const d = ctx.getImageData(0, 0, N, N).data;
    const H = 12, S = 3, V = 3, CB = H * S * V + 4;
    const col = new Float32Array(CB);
    const ori = new Float32Array(8);
    const gray = new Float32Array(N * N);
    for (let i = 0; i < N * N; i++) {
      const r = d[i * 4] / 255, g = d[i * 4 + 1] / 255, b = d[i * 4 + 2] / 255;
      const mx = Math.max(r, g, b), mn = Math.min(r, g, b), v = mx, dl = mx - mn, sat = mx ? dl / mx : 0;
      gray[i] = 0.299 * r + 0.587 * g + 0.114 * b;
      if (v > 0.93 && sat < 0.08) continue;
      const px = i % N, py = (i / N) | 0;
      const dx = (px - N / 2) / (N / 2), dy = (py - N / 2) / (N / 2);
      const wt = Math.exp(-(dx * dx + dy * dy) * 1.2);
      if (sat < 0.15) {
        col[H * S * V + Math.min(3, (v * 4) | 0)] += wt;
        continue;
      }
      let hu;
      if (mx === r) hu = ((g - b) / dl) % 6;
      else if (mx === g) hu = (b - r) / dl + 2;
      else hu = (r - g) / dl + 4;
      hu = (hu * 60 + 360) % 360;
      col[(Math.min(H - 1, (hu / 360 * H) | 0) * S + Math.min(S - 1, (sat * S) | 0)) * V + Math.min(V - 1, (v * V) | 0)] += wt;
    }
    for (let y = 1; y < N - 1; y++) {
      for (let k = 1; k < N - 1; k++) {
        const i = y * N + k;
        const gx = gray[i + 1] - gray[i - 1], gy = gray[i + N] - gray[i - N], m = Math.hypot(gx, gy);
        if (m < 0.08) continue;
        let a = Math.atan2(gy, gx);
        if (a < 0) a += Math.PI;
        ori[Math.min(7, (a / Math.PI * 8) | 0)] += m;
      }
    }
    const out = new Uint8Array(CB + 8);
    const put = (arr, offset) => {
      let total = 0;
      arr.forEach((q) => (total += q));
      arr.forEach((q, j) => (out[offset + j] = Math.round(Math.sqrt(total ? q / total : 0) * 255)));
    };
    put(col, 0);
    put(ori, CB);
    return out;
  }

  function loadIndex() {
    if (!indexPromise) {
      indexPromise = fetch(indexUrl)
        .then((response) => {
          if (!response.ok) throw new Error('Index unavailable');
          return response.json();
        })
        .then((index) => {
          const bin = atob(index.f);
          const F = new Uint8Array(bin.length);
          for (let i = 0; i < bin.length; i++) F[i] = bin.charCodeAt(i);
          return { items: index.items, dim: index.dim, F };
        })
        .catch((error) => {
          indexPromise = null;
          throw error;
        });
    }
    return indexPromise;
  }

  function rank(index, q) {
    const { F, dim, items } = index;
    const CB = 112;
    const scored = [];
    for (let i = 0; i < items.length; i++) {
      const o = i * dim;
      let c = 0, e = 0;
      for (let j = 0; j < CB; j++) {
        const diff = q[j] - F[o + j];
        c += diff * diff;
      }
      for (let j = CB; j < dim; j++) {
        const diff = q[j] - F[o + j];
        e += diff * diff;
      }
      scored.push([0.75 * c + 0.25 * e * (CB / 8) * 0.25, i]);
    }
    scored.sort((a, b) => a[0] - b[0]);
    const seen = new Set();
    const picks = [];
    for (const [, i] of scored) {
      const [handle, title, img, vid] = items[i];
      if (seen.has(handle)) continue;
      seen.add(handle);
      picks.push({ handle, title, img, vid });
      if (picks.length >= 12) break;
    }
    return picks;
  }

  const currency = () => (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP';
  const money = (cents) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: currency() }).format(cents / 100);
    } catch (error) {
      return (cents / 100).toFixed(2);
    }
  };
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function renderResults(picks) {
    results.replaceChildren();
    const heading = document.createElement('h2');
    heading.className = 'bz-search-recommended';
    heading.textContent = 'Watches that look similar';
    results.append(heading);
    picks.forEach((pick) => {
      const link = document.createElement('a');
      link.className = 'bz-search-product';
      link.href = root + 'products/' + pick.handle + (pick.vid ? '?variant=' + pick.vid : '');
      const img = document.createElement('img');
      img.src = pick.img + '?width=192';
      img.alt = pick.title;
      img.width = 96;
      img.height = 96;
      img.loading = 'lazy';
      const info = document.createElement('span');
      info.className = 'bz-search-product-info';
      const title = document.createElement('strong');
      title.textContent = pick.title;
      const price = document.createElement('span');
      price.className = 'bz-search-prices';
      info.append(title, price);
      link.append(img, info);
      results.append(link);
      fetch(root + 'products/' + pick.handle + '.js')
        .then((response) => (response.ok ? response.json() : null))
        .then((product) => {
          if (!product) {
            link.remove();
            return;
          }
          const variant = (pick.vid && product.variants.find((v) => v.id === pick.vid)) || product.variants.find((v) => v.available) || product.variants[0];
          price.textContent = money(variant.price);
          if (variant.compare_at_price > variant.price) {
            price.classList.add('bz-search-prices--sale');
            const was = document.createElement('s');
            was.textContent = money(variant.compare_at_price);
            price.append(was);
          }
          if (!product.available) {
            const sold = document.createElement('small');
            sold.textContent = 'Sold out';
            info.append(sold);
          }
        })
        .catch(() => {});
    });
    results.hidden = false;
    if (idle) idle.hidden = true;
  }

  function reset() {
    runId++;
    if (objectUrl) URL.revokeObjectURL(objectUrl);
    objectUrl = null;
    fileInput.value = '';
    preview.removeAttribute('src');
    text.textContent = '';
    panel.hidden = true;
    results.hidden = true;
    results.replaceChildren();
    if (idle && !(searchInput && searchInput.value.trim())) idle.hidden = false;
  }

  function show(message) {
    text.textContent = message;
    panel.hidden = false;
  }

  camera.addEventListener('click', () => {
    loadIndex().catch(() => {});
    fileInput.click();
  });
  remove.addEventListener('click', reset);
  dialog.addEventListener('close', reset);
  searchInput?.addEventListener('input', () => {
    if (!panel.hidden || !results.hidden) {
      const keep = searchInput.value;
      reset();
      searchInput.value = keep;
    }
  });

  fileInput.addEventListener('change', async () => {
    const file = fileInput.files && fileInput.files[0];
    if (!file) return;
    const id = ++runId;
    if (!file.type.startsWith('image/')) {
      show(dialog.dataset.visualType);
      return;
    }
    if (file.size > MAX_BYTES) {
      show(dialog.dataset.visualLarge);
      return;
    }
    if (searchInput) searchInput.value = '';
    if (typedResults) {
      typedResults.hidden = true;
      typedResults.replaceChildren();
    }
    if (objectUrl) URL.revokeObjectURL(objectUrl);
    objectUrl = URL.createObjectURL(file);
    preview.src = objectUrl;
    show(dialog.dataset.visualLoading);
    results.hidden = true;
    try {
      const [index, img] = await Promise.all([
        loadIndex(),
        new Promise((resolve, reject) => {
          const image = new Image();
          image.onload = () => resolve(image);
          image.onerror = reject;
          image.src = objectUrl;
        }),
      ]);
      if (id !== runId) return;
      const picks = rank(index, features(img));
      if (!picks.length) throw new Error('No matches');
      renderResults(picks);
      show(dialog.dataset.visualDone);
    } catch (error) {
      if (id !== runId) return;
      show(dialog.dataset.visualError);
    }
  });
})();
